import { ShopifyMetadata } from '../types/types'

export const useShopifyMetadata = () => {
  const jsonScriptTag = document.getElementById('spiff-product-json')
  const shopifyMetadata: ShopifyMetadata | null = jsonScriptTag ? JSON.parse(jsonScriptTag.innerHTML) : null

  if (!shopifyMetadata?.spiffAppKey) throw new Error('Spiff App Key is not defined in the Shopify Metadata')

  return shopifyMetadata
}

export function getShopifyMetadata(): ShopifyMetadata | null {
  const jsonScriptTag = document.getElementById('spiff-product-json')
  const shopifyMetadata: ShopifyMetadata | null = jsonScriptTag ? JSON.parse(jsonScriptTag.innerHTML) : null
  return shopifyMetadata
}
